import { render, staticRenderFns } from "./ClosingReasonsSummaryTable.vue?vue&type=template&id=c93b00c6&scoped=true&"
import script from "./ClosingReasonsSummaryTable.vue?vue&type=script&lang=js&"
export * from "./ClosingReasonsSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./ClosingReasonsSummaryTable.vue?vue&type=style&index=0&id=c93b00c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93b00c6",
  null
  
)

export default component.exports